// ADR-133 D11: unmapped titles of the last recorded run, shared by the
// Unmapped tab and its header strip.
import { useCallback, useEffect, useState } from 'react';
import { useAlert } from '../../../contexts/AlertContext';
import { ingestionConfigurationApi } from '../../../services/api/ingestionConfigurationApi';
import { needsAttention } from './unmappedTitleStatus';

/** Loads the unmapped titles; the page owns it so the header and the tab share one copy. */
const useUnmappedTitles = (provider, refreshKey, enabled) => {
  const { showAlert } = useAlert();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setData(await ingestionConfigurationApi.getUnmappedTitles(provider));
    } catch (error) {
      setData(null);
      showAlert('Failed to load unmapped titles', 'error', error);
    } finally {
      setLoading(false);
    }
  }, [provider, showAlert]);

  useEffect(() => {
    if (enabled) {
      load();
    }
  }, [enabled, load, refreshKey]);

  const titles = data?.titles || [];
  const scopedRuns = data?.scopedRuns || [];
  return {
    data,
    loading,
    titles,
    scopedRuns,
    // Anything to show at all: the last FULL run, or scoped runs (imports) since.
    hasRun: Boolean(data?.runId) || scopedRuns.length > 0,
    // Titles that only scoped runs (imports) have seen since the last full run.
    newFromScopedCount: titles.filter((t) => !t.inLastFullRun && needsAttention(t)).length,
    openCount: titles.filter(needsAttention).length,
    versionChanged: Boolean(data?.runId)
      && data.mappingSetVersionUsed !== null
      && data.currentMappingSetVersion !== data.mappingSetVersionUsed,
  };
};

export default useUnmappedTitles;
